import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { RecoilRoot } from 'recoil'

import App from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 窗口获得焦点时重新获取数据
      refetchOnWindowFocus: false,
      // 失败获取次数
      retry: 0
    }
  }
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <RecoilRoot>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </RecoilRoot>
)
